import { Crown, LogOut, User as UserIcon, Target, Shield } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function Header({ onSubmit, onOpenAuth, onOpenHunt, isHunter }) {
  const { user, logout } = useAuth();

  return (
    <header
      data-testid="app-header"
      className="fixed top-0 inset-x-0 z-40 backdrop-blur-xl bg-black/60 border-b border-white/5"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-3">
        <a href="/" data-testid="logo-link" className="flex items-center gap-2.5 group">
          <div className="relative w-9 h-9 rounded-lg bg-gradient-to-br from-neon-cyan to-neon-red flex items-center justify-center">
            <Crown className="w-5 h-5 text-black" />
          </div>
          <div className="leading-none">
            <div className="font-heading font-black text-lg tracking-tight">FameWar</div>
            <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-neon-cyan">
              puja por tu perfil
            </div>
          </div>
        </a>

        <div className="flex items-center gap-2 sm:gap-3">
          {user?.is_admin && (
            <Link
              to="/admin"
              data-testid="header-admin-link"
              className="hidden sm:inline-flex items-center gap-1.5 px-3 py-2 rounded-full bg-neon-cyan/10 border border-neon-cyan/40 text-neon-cyan text-[11px] font-mono uppercase tracking-widest hover:bg-neon-cyan/20"
            >
              <Shield className="w-3.5 h-3.5" />
              Panel Admin
            </Link>
          )}
          {user ? (
            <>
              <span
                data-testid="user-badge"
                className="hidden md:inline-flex items-center gap-2 px-3 py-2 rounded-full bg-white/5 border border-white/10 text-xs font-mono"
              >
                <UserIcon className="w-3.5 h-3.5 text-neon-cyan" />
                {user.name || user.email || user.phone || "user"}
              </span>
              <Button
                data-testid="logout-button"
                variant="ghost"
                size="sm"
                onClick={logout}
                className="text-muted-foreground hover:text-white"
              >
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <Button
              data-testid="header-login-button"
              variant="ghost"
              size="sm"
              onClick={onOpenAuth}
              className="text-sm font-mono uppercase tracking-widest hover:text-neon-cyan"
            >
              Log in
            </Button>
          )}
          <Button
            data-testid="header-join-hunt-button"
            onClick={onOpenHunt}
            variant="outline"
            size="sm"
            className={`hidden sm:inline-flex rounded-full font-mono uppercase tracking-widest text-xs ${
              isHunter
                ? "border-neon-red text-neon-red bg-neon-red/10 hover:bg-neon-red/15"
                : "border-neon-red/50 text-neon-red hover:bg-neon-red/10"
            }`}
          >
            <Target className="w-3.5 h-3.5 mr-1.5" />
            {isHunter ? "Hunter" : "Join Hunt"}
          </Button>
          <Button
            data-testid="header-submit-bid-button"
            onClick={onSubmit}
            className="bg-neon-cyan hover:bg-neon-cyan/90 text-black font-bold rounded-full px-4 sm:px-5"
          >
            Submit &amp; Bid
          </Button>
        </div>
      </div>
    </header>
  );
}

